import { Box, Flex, IconButton, Image, Input, Text } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { FaCamera } from "react-icons/fa";

interface IImageInput {
  src?: string;
  alt: string;
  errors: any;
  register: any;
  trigger: any;
}

export default function ImageInput({
  src,
  alt,
  errors,
  register,
  trigger,
}: IImageInput) {
  const displayImageRef = useRef<any>();
  const inputElementRef = useRef<HTMLInputElement | null>();

  useEffect(() => {
    if (errors.image) displayImageRef.current.scrollIntoView();
  }, [errors.image]);

  return (
    <>
      <Flex alignItems="center" direction="column">
        <Box position="relative">
          <Image
            src={src}
            alt={alt}
            height={200}
            width={200}
            fallbackSrc="https://via.placeholder.com/200/?text=Image"
            borderRadius="100%"
            ref={displayImageRef}
            border="4px solid"
            borderColor={errors.image ? "red.400" : "transparent"}
          />
          <IconButton
            position="absolute"
            right="0"
            bottom="15%"
            aria-label="Search database"
            icon={<FaCamera />}
            isRound
            onClick={() => {
              inputElementRef.current?.click();
            }}
          />
        </Box>
        {errors.image && (
          <Text fontStyle="italic" color="red.400">
            {errors.image.message}
          </Text>
        )}
      </Flex>
      <Input
        hidden
        type="file"
        name="image"
        accept="image/*"
        placeholder="Select Display Image"
        onChange={(e) => {
          let image = e.target;
          if (image === null) return;
          if ((image.files?.length ?? 0) > 0) {
            displayImageRef.current!.src = URL.createObjectURL(image.files![0]);
            image.onload = () =>
              URL.revokeObjectURL(displayImageRef.current!.src);
          }
          trigger("image");
        }}
        ref={(e) => {
          register(e, {
            // required: "Image is required",
            validate: (value: any) => {
              if (!src && value.length < 1) return "Image is Required";
              if (value.length > 0 && value[0].size > 5 * 1024 * 1024)
                return "File size cannot exceed 5MB in size!";
              return true;
            },
          });
          inputElementRef.current = e;
        }}
      />
    </>
  );
}
